import React from "react";
import moment from "moment";
import { Page } from "..";
import {
  Row,
  Col,
  Box,
  CampoTexto,
  Botao,
  TipoBotao,
  Form,
  Combo,
  Alerta,
  TipoAlerta,
} from "@intechprev/componentes-web";
import {
  PlanoVinculadoService,
  FichaContribPrevidencialService,
  IndiceService,
} from "../../services";
import { PlanoVinculadoEntidade, PlanoPrevidencialEntidade } from "../../entidades";
import _ from "lodash";

interface Props { }

const ComboPeriodo = [
  {
    Key: 999,
    Name: "TODOS OS MESES"
  },
  {
    Key: 3,
    Name: "3 MESES"
  },
  {
    Key: 6,
    Name: "6 MESES"
  },
  {
    Key: 12,
    Name: "12 MESES"
  }
];

interface State {
  plano: PlanoVinculadoEntidade;
  planos: Array<PlanoVinculadoEntidade>;
  pensionista: boolean;
  sqPlanoPrevidencial: number;
  planosVazio: boolean;

  referencia: string;
  referenciaMax: string;
  periodo: number;

  erro: string;
}

export class Extrato extends React.Component<Props, State> {
  private page = React.createRef<Page>();
  private form = React.createRef<Form>();

  constructor(props: Props) {
    super(props);

    this.state = {
      plano: new PlanoVinculadoEntidade(),
      planos: [],
      pensionista: localStorage.getItem("pensionista") === "true",
      sqPlanoPrevidencial: 0,
      planosVazio: false,

      referencia: "",
      referenciaMax: "",
      periodo: 999,

      erro: ""
    };
  }

  componentDidMount = async () => {
    this.page.current.loading(true);

    var planos = await PlanoVinculadoService.Buscar();

    if (planos.length > 0) {
      var plano = planos[0];

      const ultimaReferencia = await FichaContribPrevidencialService.BuscarUltimaReferenciaPorPlano(plano.SQ_PLANO_PREVIDENCIAL);
      const referencia = moment(ultimaReferencia.DT_REFERENCIA, "DD/MM/YYYY").format("MM/YYYY");
      const referenciaMax = moment(ultimaReferencia.DT_REFERENCIA, "DD/MM/YYYY").format("MM/YYYY");

      await this.setState({
        planos,
        plano,
        sqPlanoPrevidencial: plano.SQ_PLANO_PREVIDENCIAL,
        referencia,
        referenciaMax
      });
    } else {
      this.setState({
        planosVazio: true
      })
    }

    this.page.current.loading(false);
  };

  carregarPlano = async () => {
    var planoSelecionado = null;
    var sqPlanoPrevidencial = parseInt(this.state.sqPlanoPrevidencial.toString());

    if (this.state.sqPlanoPrevidencial)
      planoSelecionado = _.filter(this.state.planos, (plano: any) => plano.SQ_PLANO_PREVIDENCIAL === sqPlanoPrevidencial)[0];
    else
      planoSelecionado = this.state.planos[0];

    sqPlanoPrevidencial = planoSelecionado.SQ_PLANO_PREVIDENCIAL;

    this.setState({
      plano: planoSelecionado,
      sqPlanoPrevidencial
    });
  }

  gerarExtrato = async () => {
    const input = moment(this.state.referencia, "MM/YYYY");
    const max = moment(this.state.referenciaMax, "MM/YYYY");
    const DataMaiorMax = input.isAfter(max);

    if (!input.isValid()) {
      await this.setState({ erro: "Data inválida." });
      return;
    }

    if (DataMaiorMax) {
      await this.setState({ erro: `A data informada não pode ser maior que a data de referência "${this.state.referenciaMax}` });
      return;
    }

    const referencia = input.format("MM.YYYY");

    const { Url, UrlResultado } = await PlanoVinculadoService.BuscarURLExtrato(this.state.plano.SQ_PLANO_PREVIDENCIAL, this.state.periodo, referencia);

    console.log({ Url, UrlResultado });

    const tempLink = document.createElement('a');
    tempLink.href = UrlResultado;
    tempLink.setAttribute('download', "Extrato.pdf");
    tempLink.target = '_blank';
    document.body.appendChild(tempLink);
    tempLink.click();
  };

  render() {
    return (
      <Page {...this.props} ref={this.page}>
        {this.page.current && (
          <Row>
            <Col>
              <Box titulo={"Extrato de Contribuições"}>
                <Form ref={this.form}>
                  <Combo contexto={this}
                    titulo={"Selecione um plano"}
                    onChange={this.carregarPlano}
                    nome={"sqPlanoPrevidencial"}
                    valor={this.state.sqPlanoPrevidencial}
                    opcoes={this.state.planos}
                    nomeMembro={"DS_PLANO_PREVIDENCIAL"}
                    valorMembro={"SQ_PLANO_PREVIDENCIAL"}
                  />

                  <CampoTexto
                    contexto={this}
                    nome={"referencia"}
                    valor={this.state.referencia}
                    tamanhoTitulo={"lg-2"}
                    tamanhoCampo={"lg-2"}
                    titulo={"Referência"}
                    mascara={"99/9999"}
                  />

                  <Combo contexto={this}
                    titulo={"Período"}
                    nome={"periodo"}
                    valor={this.state.periodo}
                    padrao={this.state.periodo}
                    opcoes={ComboPeriodo}
                    nomeMembro={"Name"}
                    valorMembro={"Key"}
                  />

                  <Alerta
                    tipo={TipoAlerta.danger}
                    mensagem={this.state.erro}
                  />

                  <Botao
                    titulo={"Gerar"}
                    tipo={TipoBotao.primary}
                    submit
                    usaLoading
                    onClick={this.gerarExtrato}
                  />

                  <Alerta
                    className={'mt-4'}
                    tipo={TipoAlerta.info}
                    mensagem={"Caso o extrato não seja exibido, verifique se seu navegador está bloqueando pop-ups."}
                  />
                </Form>
              </Box>
            </Col>
          </Row>
        )}
      </Page>
    );
  }
}
